import React from 'react';

const StoreContext = React.createContext(null);

export default StoreContext;
